export class Memory {
    static getString(key) {
        this.addToken(key);
        if (this._useLocalStorage) {
            return localStorage.getItem(key);
        }
        else {
            return getCookie(key);
        }
    }
    static getObject(key) {
        this.addToken(key);
        var obj = null;
        var o = {};
        if (this._useLocalStorage) {
            obj = localStorage.getItem(key);
        }
        else {
            obj = getCookie(key);
        }
        try {
            var parsed = JSON.parse(obj);
            Object.assign(o, parsed);
            return o;
        }
        catch (e) {
            if (obj !== null && typeof obj === "string") {
                Object.assign(o, obj);
            }
            else {
                console.warn("Unable to retrieve object", e);
            }
            return o;
        }
    }
    static saveObject(key, value, hours = 1, days = 0) {
        if (key != this._tokensKey)
            this.addToken(key);
        var serialized = typeof value === "string" ? value : JSON.stringify(value);
        if (this._useLocalStorage) {
            localStorage.setItem(key, serialized);
        }
        else {
            setCookie(key, serialized, hours, days);
        }
    }
    static deleteObject(key) {
        if (this._useLocalStorage) {
            localStorage.removeItem(key);
        }
        else {
            deleteCookie(key);
        }
    }
    static clear() {
        //This now deletes USED tokens instead of ALL tokens
        //My fear was that we may want to keep some fields in memory instead of doing a full abandon
        //This will allow us to keep specific items in local storage/cookies and keep anything else there
        var tokens = this.getUsedTokens();
        this._doNotClearTokens.forEach((t) => {
            const idx = tokens.indexOf(t);
            if (idx > -1)
                tokens.splice(idx, 1);
        });
        if (this._useLocalStorage) {
            tokens.forEach((t) => {
                localStorage.removeItem(t);
            });
            //localStorage.clear();
        }
        else {
            tokens.forEach((t) => {
                deleteCookie(t);
            });
            /*
            var cookies = document.cookie.split(';');
            cookies.forEach(c => {
                var cName = c.substr(0, c.indexOf('='));
                deleteCookie(cName);
            });*/
        }
        tokens.forEach((t) => this.addToken(t));
    }
    static getUsedTokens() {
        var _a, _b;
        let tokens = [];
        if (this._useLocalStorage) {
            tokens = ((_a = localStorage.getItem(this._tokensKey)) !== null && _a !== void 0 ? _a : '').split(';');
        }
        else {
            tokens = ((_b = getCookie(this._tokensKey)) !== null && _b !== void 0 ? _b : '').split(';');
        }
        tokens = tokens.filter((t) => t != null && t != '');
        return tokens;
    }
    static addToken(name) {
        let tokens = this.getUsedTokens();
        if (tokens.indexOf(name) === -1) {
            tokens.push(name);
            this.saveObject(this._tokensKey, tokens.join(";"));
        }
    }
}
Memory._useLocalStorage = true;
Memory._tokensKey = 'noe-tokens';
Memory._doNotClearTokens = ['noe-settings-display', 'noe-settings-process', 'noe-settings-change'];
export function setCookie(name, val, hours = 1, days = 0) {
    const date = new Date();
    const value = val;
    const oneHour = 60 * 60 * 1000;
    const oneDay = oneHour * 24;
    date.setTime(date.getTime() + (oneDay * days) + (oneHour * hours));
    // Set it
    document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
}
export function getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");
    if (parts.length === 2) {
        return parts.pop().split(";").shift();
    }
}
export function deleteCookie(name) {
    const date = new Date();
    const oneHour = 60 * 60 * 1000;
    const oneDay = oneHour * 24;
    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * oneDay));
    // Set it to expire in the past
    document.cookie = name + "=; expires=" + date.toUTCString() + "; path=/";
}
//# sourceMappingURL=Memory.js.map